import { type ReactNode } from 'react'
import { cn } from '#app/shared/lib/misc.js'

export const SectionEyebrow = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => {
  return (
    <p
      className={cn(
        `mb-3 text-base font-bold uppercase text-primary`,
        className,
      )}
    >
      {children}
    </p>
  )
}
